export default __webpack_public_path__ + "static/media/bg-illustration.68e672e9.png";